<template>
  <main class="mb-10 md:mb-20">
    <cms-section v-if="eSpots?.[0]" :section="eSpots?.[0]" />
    <h1 class="text-10 fw-medium lh-tight mb-10">
      {{ pageHeading }}
    </h1>
    <h2 v-html="header.heading" class="text-2xl fw-medium lh-tight mb-2 mt-10" />
    <p v-html="header.paragraph" />
    <div class="my-10">
      <div
        v-for="({ icon, heading: deliveryHeading, bullets, signUpBullet, price, isLowImpact }, key) in deliveryTypes"
        :key
        v-style="{
          'gap': { sm: '1.25rem', lg: '1.9rem' },
          'grid-cols': { md: '1fr', lg: '3.75rem 1fr 9.4rem' },
        }"
        class="py-5 b-t grid"
        :class="{ 'b-b': key === deliveryTypes.length - 1 }"
      >
        <div class="flex justify-center">
          <img alt="" class="h-8" role="presentation" :src="icon">
        </div>
        <div class="relative">
          <h3 v-html="deliveryHeading" class="fw-medium" />
          <ul class="list-disc" style="padding-inline-start: 1.25rem">
            <li v-for="(bullet, i) in bullets" :key="i" v-html="bullet" class="lh-tight my-2" />
            <li v-if="signUpBullet" class="lh-tight mb-2">
              <base-interpolator :content="signUpBullet">
                <template #br>
                  <br>
                </template>
                <template #sign-up="{ args: [message] }">
                  <vf-link
                    class="uppercase"
                    to="/sign-up"
                    @click.prevent.capture="DialogSignIn.open({
                      formLocation: 'modal:single:body:none',
                    })"
                  >
                    {{ message }}
                  </vf-link>
                </template>
              </base-interpolator>
            </li>
          </ul>
          <div v-if="isLowImpact" class="mt-5 flex right-0 top-0 lg:mt-0 lg:absolute">
            <img alt="" class="mr-3" role="presentation" :src="lowImpact.icon" width="20">
            <p v-html="lowImpact.text" class="text-3" />
          </div>
        </div>
        <div class="lg:text-right">
          <p v-if="price.fee">
            <span v-html="price.fee.text" class="lg:hidden" /> <span v-html="price.fee.amount" class="fw-medium" />
          </p>
          <p v-if="price.threshold">
            <span v-html="price.threshold.text" /> <span v-html="price.threshold.amount" />
          </p>
        </div>
      </div>
    </div>
    <p
      v-for="(disclaimer, key) in deliveryDisclaimers"
      :key
      v-html="disclaimer"
      class="mb-2"
    />
    <h2 class="text-2xl fw-medium lh-tight mb-2 mt-10">
      {{ notes.heading }}
    </h2>
    <ul class="mb-2 list-disc" style="padding-inline-start: 1.25rem">
      <li v-for="(item, key) in notes.list" :key v-html="item" />
    </ul>
    <p v-html="notes.paragraph" />
    <h2 v-html="taxes.heading" class="text-2xl fw-medium lh-tight mb-2 mt-10" />
    <p v-html="taxes.paragraph" />
  </main>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
  'change-page-title': [title: string]
}>()
const { data, error } = await useApi().internal.getStaticPage('help/delivery')
const eSpots = (await useCms().getSections.generic('delivery')).data.value?.content.sections
if (!data.value) throw createError({ ...error.value, fatal: true })

const { DialogSignIn } = useDialogsStore()

const {
  deliveryDisclaimers,
  deliveryTypes,
  header,
  lowImpact,
  pageHeading,
  notes,
  taxes
} = data?.value
emit('change-page-title', pageHeading)
</script>
